import {
  SET_MASKED_DATA,
  SET_OTP_TO_MOBILE,
  SET_TIME_OUT_NOTICE,
  SET_REDIRECT_AFTER_AUTH,
  SET_DELETE_ACCOUNT_REQUESTID,
} from './types'

function setTimeOutNotice(showTimeOutNotice) {
  return {
    type: SET_TIME_OUT_NOTICE,
    payload: {
      showTimeOutNotice,
    },
  }
}

function setRedirectAfterAuth(redirectAfterAuth) {
  return {
    type: SET_REDIRECT_AFTER_AUTH,
    payload: {
      redirectAfterAuth,
    },
  }
}

function setDeleteMaskedData(maskedData) {
  return {
    type: SET_MASKED_DATA,
    payload: {
      maskedData,
    },
  }
}

function setDeleteOtpToMobile(otpToMobile) {
  return {
    type: SET_OTP_TO_MOBILE,
    payload: {
      otpToMobile,
    },
  }
}

function setDeleteRequestId(deleteRequestId) {
  return {
    type: SET_DELETE_ACCOUNT_REQUESTID,
    payload: {
      deleteRequestId,
    },
  }
}

export {
  setTimeOutNotice,
  setDeleteMaskedData,
  setDeleteOtpToMobile,
  setRedirectAfterAuth,
  setDeleteRequestId,
}
